<div class="ft-switch" [class.disabled]="disabledControl()">
    <input class="ft-switch-toggle"
           type="checkbox"
           [id]="uid"
           [disabled]="!!disabledControl()"
           [checked]="!!state()"
           (change)="onToggle($event)" />
    <label [attr.for]="uid"></label>
</div>
